import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, orderBy } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { Vector2 } from "kea-react/dist/signatureCanvas";


type Entity = models.FirmaUsuario;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    readonly?: boolean;
    error?: kea.FieldError;
    label?: string;
}

function toVector(x: Entity): Vector2[][] {
    const ret = x.Segmentos.map(x => orderBy(x.Puntos, x => x.Orden).map(y => ({ x: y.X, y: y.Y })))
    return ret;
}

function fromVector(segmentos: Vector2[][]): Entity {
    const ret = {
        Segmentos: segmentos.map(seg =>
            ({
                Puntos: seg.map((punto, i) => ({
                    Orden: i,
                    X: punto.x,
                    Y: punto.y
                } as models.PuntoFirmaUsuario))
            } as models.SegmentoFirmaUsuario)
        )
    } as Entity;
    return ret;
}

/**
* Componente para editar una firma
*/
export class FirmaComponent extends React.PureComponent<Props> {
    onChange = (x: Vector2[][]) => {
        const model = fromVector(x);
        if (this.props.onChange) this.props.onChange(model);
    }

    render() {
        return (
            <div>
                <kea.SignaturePad {... this.props} value={toVector(this.props.value)} onChange={this.onChange}  />
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/componentes/firma.tsx